import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'

import Modal from '../../../UniformComponents/Modal'
import Typography from '../../../UniformComponents/Typography'
import Button from '../../../UniformComponents/Button'

const DeletePresentationModal = ({ store }) => (
    <Modal
        show={store.deletePresentationModalVisible}
        onClose={store.handleCloseDeletePresentationModal}
    >
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
            <Typography type="h2">Confirm</Typography>

            <br />

            <Typography>Are you sure you want to delete this presentation?</Typography>

            <br />
        </div>

        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10, marginTop: 20 }}>
            <Button
                icon="far fa-trash"
                label={i18n.t('delete')}
                onClick={store.deletePresentation}
                cssClass="regular error"
            />
            <Button
                label={i18n.t('close')}
                onClick={store.handleCloseDeletePresentationModal}
                cssClass="regular tertiary"
            />
        </div>
    </Modal>
)

export default observer(DeletePresentationModal)
